exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#brand-title{font-size:3rem;font-family:Teko,sans-serif;color:#b31835;text-shadow:3px 3px #000;text-transform:uppercase;margin:0}.currency{margin-left:.5em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-beafdba2","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Navbar.vue
// module id = 134
// module chunks = 0